import * as React from "react";
import format from "date-fns/format";
import styled from "styled-components";
import { Colors } from "@blueprintjs/core";
import classNames from "classnames";
import { useCalendarContext } from "../CalendarContext";
import { GetScrollBarWidth } from "../utils/getScrollbarWidth";

export interface IWeekViewHeaderProps {}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  & > * + * {
    border-left: 1px solid black;
  }

  border-bottom: 2px solid ${Colors.BLACK};
`;

const EmptyBloc = styled.div`
  background-color: ${Colors.BLACK};
  width: 100%;
  height: 100%;
`;

const Header = styled.div`
  flex: 1;
  background-color: ${Colors.BLUE3};

  color: white;
  text-align: center;
  font-weight: bolder;
  padding: 0.5rem 0;
  font-size: larger;
  text-transform: uppercase;

  &.today {
    background-color: ${Colors.BLUE5};
  }

  &.weekend {
    background-color: ${Colors.DARK_GRAY5};
  }
`;

const scrollBarWidth = GetScrollBarWidth();

export const WeekViewHeader: React.FunctionComponent<
  IWeekViewHeaderProps
> = () => {
  const {
    keyColumnWidthInPx,
    days,
    dateFNSLocale,
    contentOverflow,
    renderDaysHeader,
    renderEmptyHeader,
  } = useCalendarContext();

  return (
    <Container>
      <div style={{ width: keyColumnWidthInPx }}>
        {" "}
        {renderEmptyHeader === undefined ? (
          <EmptyBloc />
        ) : (
          renderEmptyHeader(keyColumnWidthInPx)
        )}
      </div>

      {days.map((d) =>
        renderDaysHeader === undefined ? (
          <Header
            key={d.date.toISOString()}
            className={classNames({ today: d.isToday, weekend: d.isWeekEnd })}
          >
            {format(d.date, "EEEE dd/MM", { locale: dateFNSLocale })}
          </Header>
        ) : (
          <React.Fragment key={d.date.toISOString()}>
            {renderDaysHeader(d.date, d.isToday, d.isWeekEnd)}
          </React.Fragment>
        )
      )}
      <div style={{ width: contentOverflow ? scrollBarWidth + 1 : 0 }}>
        {renderEmptyHeader === undefined ? (
          <EmptyBloc />
        ) : (
          renderEmptyHeader(contentOverflow ? scrollBarWidth + 1 : 0)
        )}
      </div>
    </Container>
  );
};
